import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PdfViewerComponent from '../features/pdfviewer/components/PdfViewerComponent';
import {
  setPdfViewerDocumentId,
  setExpand,
  setFilterByThumbs,
  setAiFilter,
  setMyFilter,
  setSharedFilter
} from '../redux/actions/pdf-actions';
import { setAllDocuments, setFeedUrl } from '../redux/actions/player-actions';
import {
  fetchFlags,
  fetchUserFields,
  updateUserFields
} from '../redux/actions/app-actions';
import firebase from 'firebase/compat/app';
import BeatLoader from 'react-spinners/BeatLoader';
import { CONSTANTS } from '../constants/constants';
import swal from 'sweetalert2';
import { loginExchange } from '../apis/login';

class PdfViewerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      episode: null,
      episodeId: null,
      document: null,
      isEpisodeReady: false,
      authError: false
    };
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.handleBackButton();

    this.initalizePage();
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackButtonEvent);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);

    const styleTag = document.getElementById('pdf-viewer-swal-styles');
    if (styleTag) {
      styleTag.remove();
    }

    this.props.dispatch(setExpand(false));
    this.props.dispatch(setPdfViewerDocumentId(null));
    this.props.dispatch(setFeedUrl(null));
    this.props.dispatch(setAllDocuments([]));
  }

  initalizePage = async () => {
    const authenticated = await this.handleUuidAuthentication();

    if (!authenticated) {
      this.setState({ loading: false, authError: true });
      return;
    }

    this.setRequiredProps();

    await this.fetchUserData();
  };

  setRequiredProps = () => {
    this.props.dispatch(setExpand(true));
    this.props.dispatch(setFilterByThumbs(false));
    this.props.dispatch(setMyFilter(true));
    this.props.dispatch(setSharedFilter(true));
    this.props.dispatch(setAiFilter(false));
  };

  handleUuidAuthentication = async () => {
    const urlParams = new URLSearchParams(this.props.location.search);
    const uuid = urlParams.get('uuid');

    if (!uuid) {
      return false;
    }

    try {
      const response = await loginExchange(uuid);

      if (!response && !response.data) return false;

      const { accessToken, episode, episodeId } = response.data;

      if (accessToken) {
        await firebase.auth().signInWithCustomToken(accessToken);
      }

      // Map the episode to include necessary fields for PDF viewer
      const mappedEpisode = {
        ...episode,
        url: episode.episodeUrl,
        feedUrl: episode.allPodcast.podcastUrl
      };

      this.setState({
        episode: mappedEpisode,
        episodeId: episodeId,
        document: mappedEpisode.document,
        loading: false,
        isEpisodeReady: true
      });

      return true;
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false,
        isEpisodeReady: false,
        authError: true
      });
      return false;
    }
  };

  handleBeforeUnload = (e) => {
    e.preventDefault();
    e.returnValue = '';
    return '';
  };

  fetchUserData = async () => {
    return new Promise((resolve) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
        unsubscribe();

        if (!user) {
          resolve();
          return;
        }

        try {
          const token = await user.getIdToken();

          this.props.dispatch(fetchFlags(token));

          this.props.dispatch(fetchUserFields(token));
          this.props.dispatch(updateUserFields(token));

          resolve();
        } catch (error) {
          console.error(error);
          resolve();
        }
      });
    });
  };

  handleBackButton = () => {
    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', this.onBackButtonEvent);
  };

  onBackButtonEvent = (e) => {
    e.preventDefault();

    window.history.pushState(null, '', window.location.pathname);

    swal({
      imageUrl: CONSTANTS.swalLogo,
      title: '<div class="titleModal">PDF Viewer</div>',
      html:
        '<p class="contentModal">Please close this tab to leave the PDF viewer page.</p>',
      showCancelButton: false,
      showCloseButton: true,
      showConfirmButton: false,
      background: '#121C24',
      allowOutsideClick: true
    });
  };

  handleClosePdfViewer = () => {
    this.props.history.push('/dashboard');
  };

  handleClickExpand = () => {
    this.props.dispatch(setExpand(!this.props.expand));
  };

  isLeaveMode = () => {
    const params = new URLSearchParams(this.props.location.search);
    const leave = params.get('leave');

    return leave;
  };

  render() {
    const {
      loading,
      episode,
      document,
      isEpisodeReady,
      authError
    } = this.state;

    if (this.isLeaveMode()) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#121C24',
            flexDirection: 'column'
          }}
        >
          <div
            style={{ color: '#E31690', fontSize: '48px', marginBottom: '20px' }}
          >
            🚫
          </div>
          <p style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>
            Navigation Restricted
          </p>
          <p style={{ color: '#7d7d7f', marginTop: '10px' }}>
            Please open <strong>Inflo Web</strong> to navigate to more pages.
          </p>
        </div>
      );
    }

    if (authError) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#121C24',
            flexDirection: 'column'
          }}
        >
          <div
            style={{ color: '#E31690', fontSize: '48px', marginBottom: '20px' }}
          >
            ⚠️
          </div>
          <p style={{ color: 'white', fontSize: '24px', fontWeight: 'bold' }}>
            Failed to Verify User
          </p>
          <p style={{ color: '#7d7d7f', marginTop: '10px' }}>
            Unable to authenticate your session. Please try again.
          </p>
        </div>
      );
    }

    if (loading || !isEpisodeReady) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#121C24',
            flexDirection: 'column'
          }}
        >
          <BeatLoader size={15} color={'#E31690'} />
          <p style={{ color: 'white', marginTop: '20px' }}>
            Loading PDF Viewer...
          </p>
        </div>
      );
    }

    if (!episode || !document) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#121C24',
            color: 'white',
            fontSize: '18px'
          }}
        >
          No episode data available
        </div>
      );
    }

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#121C24'
        }}
      >
        <PdfViewerComponent
          newNotes={this.props.notes || []}
          document={document}
          episode={episode}
          expand={this.props.expand}
          handleClickExpand={this.handleClickExpand}
          handleClosePdfViewer={this.handleClosePdfViewer}
          fromPdfViewerPage={true}
          episodeId={this.state.episodeId}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    notes: store.app.notes,
    allEpisodes: store.player.allEpisodes,
    expand: store.pdf.expand,
    pdfViewerEpisodeId: store.pdf.pdfViewerEpisodeId,
    feedUrl: store.player.feedUrl
  };
};

export default withRouter(connect(mapStateToProps)(PdfViewerPage));
